import webAPI from "@/api/productWebsite";
import prodAPI from "../../api/products";

const state = () => ({
  websiteDetails: {},
  websiteDetailsLoading: false,
  updateWebsiteDetailsLoading: false,
  websiteTariffs: [],
  websiteTariffsLoading: false,
  websiteAddons: [],
  websiteAddonsLoading: false,
  updateProductLoading: false,
  searchedDomains: {},
  searchedDomainsLoading: false,
  selectedDomain: {},
  convertProductToWebLoading: false,
});

const mutations = {
  setSelectedDomain(state,data){
    if(data===null){ state.selectedDomain = {}; }else{
      let array = data.split('.');
      state.selectedDomain = {
        name: array[0],
        tld: data.replace(array[0],''),
        full: data
      };
    }
  },
  setWebsiteDetails(state,data){
    state.websiteDetails = data;
    state.websiteDetailsLoading = false;
  },
  setWebsiteDetailsLoading(state,data){state.websiteDetailsLoading = data;},
  setUpdateWebsiteDetailsLoading(state,data){state.updateWebsiteDetailsLoading = data;},
  setSearchedDomains(state,data){
    state.searchedDomains = data;
    state.searchedDomainsLoading = false;
  },
  setSearchedDomainsLoading(state,data){state.searchedDomainsLoading = data;},
  setWebsiteTariffs(state,data){
    state.websiteTariffs = data;
    state.websiteTariffsLoading = false;
  },
  setWebsiteTariffsLoading(state,data){state.websiteTariffsLoading = data;},
  setWebsiteAddons(state,data){
    data = data.map(add=>{return {
      id: add.id,
      name: add.name,
      price: add.standard_price,
      quantity: 0,
      total: '£0.00',
    }});
    state.websiteAddons = data;
    state.websiteAddonsLoading = false;
  },
  setWebsiteAddonsLoading(state,data){state.websiteAddonsLoading = data;},
  setUpdateProductLoading(state,data){state.updateProductLoading = data;},
  setConvertProductToWebLoading(state,data){state.convertProductToWebLoading = data;},
};

const tariffVersion = (version)=>{
  return version.replace('TARIFF_V','');
}

const actions = {
  async fetchSearchedDomains({ commit,dispatch }, data) {
    commit('setSearchedDomainsLoading',true);
    try{
      let res = await webAPI.fetchSearchedDomains(data);
      if(res.status===200){
        commit("setSearchedDomains",res.data.results);
      }else{
        commit("setSearchedDomains",{});
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.results.message}, { root: true });
      }
    }catch(err){
      commit("setSearchedDomains",{});
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.results.message}, { root: true });
    }
  },
  async fetchWebsiteDetails({ commit,dispatch,rootState }) {
    commit('setWebsiteDetailsLoading',true);
    try{
      let res = await webAPI.fetchWebsiteDetails(rootState.products.currentProduct.id);
      if(res.status===200){
        commit("setWebsiteDetails",res.data);
      }else{
        commit("setWebsiteDetails",{});
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit("setWebsiteDetails",{});
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },
  async fetchAllTariffs({ commit,dispatch,rootState }) {
    commit('setWebsiteTariffsLoading',true);
    try{
      let res = await prodAPI.getAllTariffs(tariffVersion(rootState.products.currentProduct.tariff_version),rootState.products.currentProduct.product_kind);
      if(res.status===200){
        commit("setWebsiteTariffs",res.data);
      }else{
        commit("setWebsiteTariffs",[]);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit("setWebsiteTariffs",[]);
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },
  async fetchAllAddons({ commit,dispatch,rootState }) {
    commit('setWebsiteAddonsLoading',true);
    try{
      let res = await prodAPI.getAllAddons([rootState.products.currentProduct.product_kind], tariffVersion(rootState.products.currentProduct.tariff_version));
      if(res.status===200){
        commit("setWebsiteAddons",res.data);
      }else{
        commit("setWebsiteAddons",[]);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit("setWebsiteAddons",[]);
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },
  async updateProduct({ commit,dispatch,rootState }, data ) {
    commit('setUpdateProductLoading',true);
    try{
      let id = rootState.products.currentProduct.id;
      let res = await prodAPI.updateProduct(id,data.updateData);
      if(res.status===200){
        dispatch("products/updateMainProduct", res.data, { root: true });
        dispatch("alerts/setAlert", {type: "success",message: data.success}, { root: true });
        commit('setUpdateProductLoading',false);
        return true;
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        commit('setUpdateProductLoading',false);
      }
      return false;
    }catch(err){
      commit('setUpdateProductLoading',false);
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
      return false;
    }
  },
  async updateWebsiteDetails({ commit,dispatch,rootState }, data ) {
    commit('setUpdateWebsiteDetailsLoading',true);
    try{
      let id = rootState.products.currentProduct.id;
      let res = await webAPI.updateWebsiteDetails(id,data);
      if(res.status===200){
        commit("setWebsiteDetails",res.data);
        commit('setUpdateWebsiteDetailsLoading',false);
        dispatch("alerts/setAlert", {type: "success",message: 'Domain details updated successfully!'}, { root: true });
        return true;
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        commit('setUpdateWebsiteDetailsLoading',false);
      }
      return false;
    }catch(err){
      commit('setUpdateWebsiteDetailsLoading',false);
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
      return false;
    }
  },
  async convertProductToWeb({ commit,dispatch,rootState } ) {
    commit('setConvertProductToWebLoading',true);
    try{
      let id = rootState.products.currentProduct.id;
      let res = await webAPI.convertProductToWeb(id);
      if(res.status===200){
        commit('setConvertProductToWebLoading',false);
        return true;
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        commit('setConvertProductToWebLoading',false);
      }
      return false;
    }catch(err){
      commit('setConvertProductToWebLoading',false);
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
      return false;
    }
  },
};

const getMonths = (min)=>{
  let months = [1,12,18,24,36,48];
  months.length = (months.indexOf(min)+1);
  return months.map(m=>{return{
    months: m,
    name: (m===1)?`Month to month`:`${m} Months`,
  }});
}

const getPromos = (promos)=>{
  return promos.filter(e=> e.available ).map(pro=>({
    id: pro.promo.id,
    name: pro.promo.name,
    price: (pro.promo.price!==null)?parseFloat(pro.promo.price).toFixed(2):'0.00',
    months: pro.promo.min_contract_length_months,
  }));
};

const sortTariffs = (tariffs,returnType)=>{
  let retTariffs = (returnType==='object')?{}:[];
  tariffs.forEach(tar => {
    let obj = {
      id: tar.id,
      name: `${tar.name} - £${tar.standard_price}`,
      price: (tar.standard_price!==null)?parseFloat(tar.standard_price).toFixed(2):'0.00',
      months: getMonths(tar.min_contract_length_months),
      promos: getPromos(tar.promos),
    };
    if(returnType==='object'){
      retTariffs[tar.id] = obj;
    }else{
      retTariffs.push(obj);
    }
  });
  return retTariffs;
}

const sortPromos = (tariffs)=>{
  let promos = {};
  tariffs.forEach(tar => {
    tar.promos.forEach(proOuter => {
      if(proOuter.available){
        const pro = proOuter.promo;
        promos[pro.id] = {
          id: pro.id,
          name: pro.name,
          price: (pro.price!==null)?parseFloat(pro.price).toFixed(2):'0.00',
          months: (pro.length_months!==1)?`${pro.length_months} Months`:`${pro.length_months} Month`,
        }
      }
    });
  });
  return promos;
}

const addonsObject = (addons)=>{
  let addonsObj = {};
  addons.forEach(add => { addonsObj[add.id] = add; });
  return addonsObj;
}

const sortCurrentAddons = (addons,rootState)=>{
  if(rootState.products.currentProduct.addons.length===0){ return []; }
  let allAddons = addonsObject(addons);
  let retAddons = [];
  rootState.products.currentProduct.addons.forEach(add => {
    if(allAddons[add.addon_id]!==undefined){
      allAddons[add.addon_id].quantity = add.quantity;
      allAddons[add.addon_id].total = `£${(add.quantity * parseFloat(allAddons[add.addon_id].price)).toFixed(2)}`;
      retAddons.push(allAddons[add.addon_id]);
    }
  });
  return retAddons;
}

const getters = {
  getWebsiteProductLoading(state,getters,rootState){
    return state.websiteDetailsLoading||state.websiteTariffsLoading||state.websiteAddonsLoading;
  },
  getTopBar(state,getters,rootState){
    let prod = rootState.products.currentProduct;
    let acc = rootState.accounts.currentAccount;
    if(acc.business_name!==undefined){
      return {
        title: `${prod.id} - ${acc.business_name}`,
        breadcrumbs: [
          {text:`Billing Accounts`,disabled:false,href:`/accounts/`},
          {text:`${acc.id}`,disabled:false,href:`/accounts/${acc.id}`},
          {text:`Products`,disabled:false,href:`/products/`},
          {text:prod.id,disabled:true,href:`/products/${prod.id}`},
        ]
      }
    }else{
      return {
        title: 'New website',
        breadcrumbs: [
          {text:`Products`,disabled:false,href:`/products/`},
          {text:prod.id,disabled:true,href:`/products/${prod.id}`},
        ]
      }
    }
  },
  getCurrentProduct: (state,getters,rootState)=>{
    return rootState.products.currentProduct;
  },
  getLinkedAccount: ()=>{
    return rootState.accounts.currentAccount;
  },
  getCurrentProductAddons: (state,getters,rootState)=>{
    return sortCurrentAddons(state.websiteAddons,rootState);
  },
  getWebsiteTariffs: (state)=>{
    return sortTariffs(state.websiteTariffs,'array');
  },
  getWebsiteTariffByID: (state,getters,rootState)=>{
    let tariffs = sortTariffs(state.websiteTariffs,'object');
    return (tariffs[rootState.products.currentProduct.tariff_id]!==undefined)?tariffs[rootState.products.currentProduct.tariff_id]:{};
  },
  getWebsitePromoByID: (state,getters,rootState)=>{
    let promos = sortPromos(state.websiteTariffs);
    return (promos[rootState.products.currentProduct.promo_id]!==undefined)?promos[rootState.products.currentProduct.promo_id]:{};
  },
  getSearchedDomains: (state)=>{
    if(state.searchedDomains.lookup===undefined){ return []; }
    let domains = [];
    state.searchedDomains.lookup.forEach(dom => {
      domains.push({
        name: dom.domain,
        status: dom.status,
        selected: false,
        type: 'lookup',
      });
    });
    let limit = 12 - domains.length;
    state.searchedDomains.suggestion.forEach((dom,ind) => {
      if(ind+1<=limit){
        domains.push({
          name: dom.domain,
          status: dom.status,
          selected: false,
          type: 'suggested',
        });
      }
    });
    return domains;
  },
  getCurrentAdditionalEmailAddons(state,getters,rootState){
    let emails = sortCurrentAddons(state.websiteAddons,rootState).filter(e => {
      if(e.name==='Additional Email Address'){ return e; }
      return;
    })[0];
    return (emails!==undefined)?emails.quantity+1:1;
  },
  getCurrentEmailsToEdit: (state,getters,rootState)=>{
    let emails = sortCurrentAddons(state.websiteAddons,rootState).filter(e => {
      if(e.name==='Additional Email Address'){ return e; }
      return;
    })[0];
    if(emails===undefined){ emails={quantity:0}; }
    let inputs = [];
    let currentEmails = state.websiteDetails.email_addresses;
    for (let ind = 1; ind <= emails.quantity+1; ind++) {
      inputs.push({
        id: ind,
        email: (currentEmails!==null)?(currentEmails[ind-1]!==undefined)?currentEmails[ind-1]:'':'',
      });
    }
    return inputs;
    return [];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  